module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Forest Ghost")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "book-title"
  }, [_vm._v("FOREST GHOST")]), _vm._v(" "), _c('h2', {
    staticClass: "book-author"
  }, [_vm._v("Graham Masterton")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "publisher-logo"
  }, [_c('img', {
    attrs: {
      "alt": "logo missing",
      "height": "51",
      "src": "images/logo.jpg",
      "width": "72"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a12affa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/title.vue
// module id = 66
// module chunks = 0